import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoriesService } from 'src/app/services/categori.service';

@Component({
  standalone: false,
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.css'],
})
export class DeliveryComponent implements OnInit {
  regions: any[] = [];
  addForm: FormGroup;
  editForm: FormGroup;
  editingRegion: any = null;

  constructor(private rest: CategoriesService, private fb: FormBuilder) {
    this.addForm = this.fb.group({
      name: ['', Validators.required],
      name_ar: [''],
      price: ['', [Validators.required, Validators.min(0)]],
    });
    this.editForm = this.fb.group({
      id: [''],
      name: ['', Validators.required],
      name_ar: [''],
      price: ['', [Validators.required, Validators.min(0)]],
    });
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.rest.getDeliveryRegions().subscribe((res: any) => {
      this.regions = res || [];
    });
  }

  add() {
    if (this.addForm.invalid) return;
    this.rest.addDeliveryRegion(this.addForm.value).subscribe(() => {
      this.rest.successToast('toast.saved');
      this.addForm.reset();
      this.load();
    });
  }

  openEdit(region: any) {
    this.editingRegion = region;
    this.editForm.patchValue(region);
  }

  saveEdit() {
    if (this.editForm.invalid) return;
    this.rest.updateDeliveryRegion(this.editForm.value).subscribe(() => {
      this.rest.successToast('toast.saved');
      this.editingRegion = null;
      this.load();
    });
  }

  cancelEdit() {
    this.editingRegion = null;
  }

  delete(id: number) {
    this.rest.deleteDeliveryRegion(id).subscribe(() => {
      this.rest.successToast('toast.deleted');
      this.load();
    });
  }
}
